export default "__VITE_ASSET__D$VZ_dVY__"